"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useOptimize = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _actions = require("../actions");

var _constants = require("../constants");

var _useTelemetry2 = require("./useTelemetry");

var _utils = require("../utils");

var OPTIMIZE_SESSION_TIMEOUT = 1000;

var useOptimize = function useOptimize() {
  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      trackerUuid = _useState2[0],
      setTrackerUuid = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      experimentActivations = _useState4[0],
      setExperimentActivations = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      featureFlags = _useState6[0],
      setFeatureFlags = _useState6[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useTelemetry = (0, _useTelemetry2.useTelemetry)(),
      isAuthenticated = _useTelemetry.isAuthenticated,
      attributes = _useTelemetry.userProperties,
      waitForAuthentication = _useTelemetry.waitForAuthentication,
      identityId = _useTelemetry.identityId,
      globalRouteContext = _useTelemetry.globalRouteContext;

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state[_constants.OPTIMIZE_REDUCER];
  }),
      experimentsByKey = _useSelector.experimentsByKey,
      featuresByKey = _useSelector.featuresByKey;

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _redux.bindActionCreators)(_actions.optimizeActions, dispatch);
  }, [dispatch]),
      postOptimizeActivate = _useMemo.postOptimizeActivate,
      optimizeSessionTimeout = _useMemo.optimizeSessionTimeout,
      enabledFeature = _useMemo.enabledFeature,
      enabledFeatures = _useMemo.enabledFeatures;

  var optimizeTimeout = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // eslint-disable-next-line prefer-const
    var timeout;

    var checkForUuid = function checkForUuid() {
      var trackerUuid;

      try {
        var _window$localStorage;

        trackerUuid = (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem(_useTelemetry2.STORAGE_KEYS.trackerUuid);
      } catch (e) {
        return;
      }

      if (trackerUuid) {
        setTrackerUuid(trackerUuid);
      } else {
        timeout = setTimeout(checkForUuid, 10);
      }
    };

    checkForUuid();
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (experimentActivations.length > 0 && (!waitForAuthentication || isAuthenticated)) {
      if (trackerUuid) {
        if (optimizeTimeout.current) {
          clearTimeout(optimizeTimeout.current);
          optimizeTimeout.current = null;
        }

        experimentActivations.forEach(function (_ref) {
          var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
              experimentKey = _ref2[0],
              ignoreIdentify = _ref2[1];

          (0, _utils.log)("Optimize experiment experimentKey:".concat(experimentKey, " activated."));
          postOptimizeActivate(experimentKey, {
            identityId: identityId,
            trackerId: trackerUuid,
            attributes: attributes
          }, ignoreIdentify, globalRouteContext);
        });
        setExperimentActivations([]);
      } else {
        (0, _utils.log)("Optimize timeout: ".concat(OPTIMIZE_SESSION_TIMEOUT, "ms no trackerUuid"), _utils.LEVELS.ERROR);
        optimizeTimeout.current = setTimeout(function () {
          return experimentActivations.forEach(function (_ref3) {
            var _ref4 = (0, _slicedToArray2["default"])(_ref3, 1),
                experimentKey = _ref4[0];

            return optimizeSessionTimeout(experimentKey);
          });
        }, OPTIMIZE_SESSION_TIMEOUT);
      }
    } // globalRouteContext is a reference
    // eslint-disable-next-line

  }, [attributes, experimentActivations, postOptimizeActivate, trackerUuid, isAuthenticated, experimentsByKey, waitForAuthentication, optimizeSessionTimeout, identityId]);
  (0, _react.useEffect)(function () {
    if (featureFlags.length > 0 && (!waitForAuthentication || isAuthenticated) && trackerUuid) {
      featureFlags.forEach(function (featureKey) {
        (0, _utils.log)("Optimize feature flag featureKey:".concat(featureKey, " enabled."));
        enabledFeature(featureKey, {
          identityId: identityId,
          trackerId: trackerUuid,
          attributes: attributes
        }, globalRouteContext);
      });
      setFeatureFlags([]);
    } // globalRouteContext is a reference
    // eslint-disable-next-line

  }, [attributes, featureFlags, enabledFeature, identityId, trackerUuid, isAuthenticated, waitForAuthentication]);
  return {
    experimentsByKey: experimentsByKey,
    featuresByKey: featuresByKey,
    optimizeActivate: (0, _react.useCallback)(function (key) {
      var ignoreIdentify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      setExperimentActivations(function (experimentActivations) {
        return [].concat((0, _toConsumableArray2["default"])(experimentActivations), [[key, ignoreIdentify]]);
      });
    }, []),
    enabledFeature: (0, _react.useCallback)(function (key) {
      setFeatureFlags(function (featureFlags) {
        return [].concat((0, _toConsumableArray2["default"])(featureFlags), [key]);
      });
    }, []),
    enabledFeatures: (0, _react.useCallback)(function () {
      if ((!waitForAuthentication || isAuthenticated) && trackerUuid) {
        (0, _utils.log)("Get all feature flags enabled.");
        enabledFeatures({
          identityId: identityId,
          trackerId: trackerUuid,
          attributes: attributes
        }, globalRouteContext);
      } // globalRouteContext is a reference
      // eslint-disable-next-line

    }, [attributes, enabledFeatures, identityId, trackerUuid, isAuthenticated, waitForAuthentication])
  };
};

exports.useOptimize = useOptimize;
var _default = useOptimize;
exports["default"] = _default;